import { useNavigate } from "react-router-dom";
import React, { useState, useContext, useEffect, useRef } from "react";
import axios from "axios";
//import { AuthInfoContext } from "./AuthContextProvider.tsx";
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
// import FormControlLabel from '@mui/material/FormControlLabel';
// import Checkbox from '@mui/material/Checkbox';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { API, MSG, SET_ENV, ENV } from "./constantsFront";
import { MsgContext } from "../../App";
import { getBackdropUtilityClass } from "@mui/material";
import crypto from "crypto-js"

function Copyright(props) {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      ID・パスワードに関するお問い合わせ先<br />
      TEL:03-0000-0000<br />
      (9:00～17:00 土日祝除く)<br />
      {'Copyright : Ministry of Agriculture, Forestry and Fisheries'}
    </Typography>
  );
}

const theme = createTheme();

const G009AdminLogin = () => {
  const [staffId, setStaffId] = useState("");
  const [password, setPassword] = useState("");
  const [errorStaffId, setErrorStaffId] = useState("");
  const [errorPassword, setErrorPassword] = useState("");
  const navigate = useNavigate();
  // エラーメッセージ
  const { msg, setMsg } = useContext(MsgContext);

  let body = { authKey: API.API_KEY };

  // useEffect初回読込フラグ
  const refIsFirst = useRef(true);

  // 初期表示
  useEffect(() => {
    // 初回読込チェック
    if (!refIsFirst.current) {
      return;
    }

    // 本番 ユーザサイトの場合、管理画面を表示しないようにする
    if (SET_ENV == ENV.USER) {
      navigate("/");
    }

    // 初回読込フラグをfalseにセット
    refIsFirst.current = false;
  }, [])

  const loginClick = async () => {
    try {
      if (!staffId) {
        setErrorStaffId(
          "社員IDを入力してください"
        );
      } else {
        setErrorStaffId("");
      }

      if (!password) {
        return setErrorPassword(
          "パスワードを入力してください"
        );
      } else {
        setErrorPassword("");
      }
      if (!staffId || !password) {
        return;
      }

      body.staffId = staffId;
      body.password = password;
      let res;

      //ログイン認証チェック
      res = await axios.post("/m_staff/auth_check", body)
        .catch(error => {
          setMsg(MSG.EXCEPTION);
          return;
        });


      if (res.data.result == "OK") {
        const staffName = res.data.staffName;
        //setAuthInfo({ userId: staffId, staff_name: staffName });
        navigate("/G011NewsList");
      } else if (res.data.result == "NG") {
        setErrorPassword(
          "ID・またはパスワードが違います"
        );
      } else if (res.data.result == "COUNT") {
        setErrorPassword(
          // "ID/パスワードがロックされているため、ログインできません。ロック解除の手続きを行ってください。"
          "ログインできません。"
        );
      }

      // // IDが一致した場合の処理
      // if (res.data.dataList.length == 1) {
      //   // 失敗回数を超えていたらメッセージを表示し処理終了
      //   if (res.data.dataList[0].fail_count >= 3) {
      //     setErrorPassword(
      //       // "ID/パスワードがロックされているため、ログインできません。ロック解除の手続きを行ってください。"
      //       "ログインできません。"
      //     );
      //     return;
      //   }

      //   // 復号化
      //   const decrypted = crypto.AES.decrypt(res.data.dataList[0].password, 'key').toString(crypto.enc.Utf8);
      //   if (password == decrypted) {
      //     const staffName = res.data.dataList[0].staff_name;
      //     setAuthInfo({ userId: staffId, passWord: password, staff_name: staffName });

      //     // 失敗回数リセット
      //     body.failCount = 0;
      //     body.staffId = staffId;
      //     const result = await axios.post("/m_staff/update/fail_count", body);

      //     navigate("/G011NewsList");
      //     return;
      //   } else {
      //     setErrorPassword(
      //       "ID・またはパスワードが違います"
      //     );
      //     // 失敗回数+1
      //     body.failCount = res.data.dataList[0].fail_count + 1;
      //     body.staffId = staffId;
      //     const result = await axios.post("/m_staff/update/fail_count", body);

      //     return;
      //   }
      // } else if (res.data.dataList.length > 1) {
      //   // 現状入ることはない
      //   setMsg("例外が発生しました。管理者にお問い合わせください。");
      //   return;
      // } else {
      //   setErrorPassword(
      //     "ID・またはパスワードが違います"
      //   );
      //   return;
      // }
    } catch (err) {
      return new Error(err.message);
    }
  }

  return (
    <ThemeProvider theme={theme}>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Typography component="h1" variant="h5" align="center">
            海外の食品規則チェックサイト<br />
            管理画面
          </Typography>
          {/* {errorText} */}
          <Box component="form" noValidate sx={{ mt: 3 }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  id="staff_id"
                  label="社員ID"
                  name="staff_id"
                  autoComplete="staff_id"
                  onChange={(event) => setStaffId(event.target.value)}
                  value={staffId}
                  error={Boolean(errorStaffId == "" ? false : true)}
                  helperText={errorStaffId}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  name="password"
                  label="パスワード"
                  type="password"
                  id="password"
                  autoComplete="new-password"
                  onChange={(event) => setPassword(event.target.value)}
                  value={password}
                  error={Boolean(errorPassword == "" ? false : true)}
                  helperText={errorPassword}
                />
              </Grid>
              {/* <Grid item xs={12}>
                <FormControlLabel
                  control={<Checkbox value="allowExtraEmails" color="primary" />}
                  label="I want to receive inspiration, marketing promotions and updates via email."
                />
              </Grid> */}
            </Grid>
            <Button
              type="button"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              onClick={loginClick}
            >
              ログイン
            </Button>
          </Box>
        </Box>
        <Copyright sx={{ mt: 5 }} />
      </Container>
    </ThemeProvider>

  );
};

export default G009AdminLogin;